import { render, staticRenderFns } from "./InstructiveSection.vue?vue&type=template&id=04fb5b86&scoped=true&"
import script from "./InstructiveSection.vue?vue&type=script&lang=js&"
export * from "./InstructiveSection.vue?vue&type=script&lang=js&"
import style0 from "./InstructiveSection.vue?vue&type=style&index=0&id=04fb5b86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fb5b86",
  null
  
)

export default component.exports